import { ColorsService } from "@arch/domain/application/services/colors.service";

export const ThemesCustom: Record<string, Record<string, string>> = {
    default: {
        "cyan-primary": ColorsService.getColor("cyan-primary"),
        "yellow-dark": ColorsService.getColor("yellow-dark"),
        "purple-dark": ColorsService.getColor("purple-dark")
    },
    theme2: {
        "cyan-primary": "#334E80",
        "yellow-dark": "#C97F6F",
        "purple-dark": "#BF5B04"
    },
    theme3: {
        "cyan-primary": "#066CC7",
        "yellow-dark": "#737A0C",
        "purple-dark": "#BF8830"
    },
    theme4: {
        "cyan-primary": "#D9731A",
        "yellow-dark": "#3D9422",
        "purple-dark": "#066CC7"
    },
    theme5: {
        "cyan-primary": "#915C6D",
        "yellow-dark": "#BF5B04",
        "purple-dark": "#487D6B"
    },
    theme6: {
        "cyan-primary": "#D4786C",
        "yellow-dark": "#805E8F",
        "purple-dark": "#3E92CC"
    }
};
